<template lang="pug">
  dropdown.locales(
    v-if='!!locales'
    :class='size'
    :options='locales'
    :showOptions='showLocales'
    @hideMenu='showLocales = false'
    optionsClassVariable='locale-options'
  )
    button.row.middle.cursor-default(type='button' @click='showLocales = true' :disabled='disabled' :class="{ 'cursor-not-clickable': locales.length < 2 }")
      img.locale-icon.m-right-1(:src='languageSelected.icon' :alt='languageSelected.lang')
      simple-svg.locale-select(
        v-if='locales.length > 1'
        :filepath='arrowDown'
        :width='arrowSize'
        :height='arrowSize'
        :class='{ rotate: showLocales, "white-icon": contrast }'
      )
</template>

<script>
import { mapActions, mapState } from 'vuex'
import amplitude from 'amplitude-js'
import Dropdown from '@/components/Dropdown'
import { supportedLanguages } from '@/constants/languages'
import arrowDown from '@/assets/ic_chevron-down.svg'
import { i18n, innerI18n } from '../../main'
import { routes } from '../../router'
import { mapLanguageOptions } from '../../constants/languages'

export default {
  data() {
    return {
      arrowDown,
      showLocales: false
    }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale,
      innerLocale: state => state.behavior.innerLocale
    }),
    arrowSize() {
      return this.size === 'big' ? '15px' : '10px'
    },
    languageSelected() {
      return this.inner
        ? supportedLanguages.find(lang => lang.lang === this.innerLocale)
        : supportedLanguages.find(lang => lang.lang === this.locale)
    },
    locales() {
      var tempLangs = this.languages ? supportedLanguages.filter(lang => this.languages.includes(lang.lang)) : supportedLanguages
      if (this.$route.path.includes(routes.faqs)) {
        tempLangs = tempLangs.filter(l => l.lang === 'ES_AR')
      }
      const langs = tempLangs
        .map(mapLanguageOptions)
        .map(lang => ({ ...lang, handleClick: () => this.changeLaguange(lang.lang) }))
      return this.languages.length < supportedLanguages.length
        ? [...langs, { label: `<h2 class="text-normal">${i18n.t('krea.languageSelector.addLanguage')}</h2>`, handleClick: this.addNewLanguage }]
        : langs
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'changeLocale',
      'changeInnerLocale'
    ]),
    changeLaguange(locale) {
      if (this.inner) {
        this.changeInnerLocale(locale)
        innerI18n.locale = locale
        amplitude.getInstance().logEvent('Change Resource Language', { language: locale })
        this.$emit('change-resource-locale', locale)
      } else {
        this.$i18n.locale = locale
        this.changeLocale(locale)
        amplitude.getInstance().logEvent('Change Language', { language: locale })
      }
      this.showLocales = false
    },
    addNewLanguage() {
      if (this.view === 'content') {
        this.$router.push({
          name: routes.kreaCreateEducationalContent,
          query: { contentId: this.viewId, setting: 'language' }
        })
      }
      if (this.view === 'resource') {
        this.showElement({
          element: 'addKreaResourceLanguageModal',
          props: {
            languages: this.languages,
            id: this.viewId
          }
        })
      }
    }
  },
  props: {
    size: { type: String, required: false, default: 'normal' },
    contrast: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    inner: { type: Boolean, required: false, default: false },
    languages: { type: Array, required: false },
    inNavigation: { type: Boolean, required: false, default: false },
    view: { type: String, default: 'content' },
    viewId: { type: Number, required: true }
  },
  components: { Dropdown }
}
</script>

<style lang="scss" scoped>
.locales {
  --container-size: 150px;
  --top-position: calc(100% + 20px);
  --right-position: -15px;
  &.big {
    height: 20px;
    width: 160px;

    .locale-icon {
      margin-right: 20px;
      width: 25px;
      display: flex;
      justify-content: center;
    }

    .locale-select {
      width: 20px;
    }
  }
}

.language-options {
  right: 0;
  width: 200px;
}

.cursor-not-clickable {
  cursor: default;
}

.locale-select {
  width: 10px;

  &.rotate {
    transform: rotate(180deg);
  }
}
</style>
